<template>
  <div class="uk-container">
    <user-update :type="3" :uid="$route.params.user" />
  </div>
</template>

<script>
import UserUpdate from '@/components/user/Manage.vue'

export default {
  name: 'ViewDentistUserManage',

  components: { UserUpdate }
}
</script>
